import * as SliderPrimitive from "@radix-ui/react-slider";
import { Flame } from "lucide-react";
import { SPICE_LEVELS, spiceInfo, SPICE_GRADIENT } from "../lib/spice";

/**
 * Drag slider that sets a per-dish spice level.
 * The track shows the full heat gradient; the labelled thumb snaps across 5 stops.
 */
export const SpiceSlider = ({ value = 2, onChange, testId = "spice-slider" }) => {
  const active = spiceInfo(value);

  return (
    <div className="mt-2 rounded-lg bg-white/70 px-2.5 py-2">
      <div className="mb-1.5 flex items-center justify-between">
        <span className="flex items-center gap-1 font-poster text-[9px] font-bold uppercase tracking-widest text-nosh-ink/45">
          <Flame className="h-3 w-3" style={{ color: active.color }} />
          Spice level
        </span>
        <span
          data-testid={`${testId}-label`}
          className="font-poster text-[11px] font-bold leading-none"
          style={{ color: active.color }}
        >
          {active.name}
          <span className="ml-1 font-body text-[10px] font-normal text-nosh-ink/40">
            {active.en}
          </span>
        </span>
      </div>

      <SliderPrimitive.Root
        data-testid={testId}
        min={0}
        max={4}
        step={1}
        value={[value]}
        onValueChange={(v) => onChange(v[0])}
        aria-label="Spice level"
        className="relative flex h-5 w-full touch-none select-none items-center"
      >
        <SliderPrimitive.Track
          className="relative h-2 w-full grow overflow-hidden rounded-full"
          style={{ background: SPICE_GRADIENT }}
        />
        <SliderPrimitive.Thumb
          className="block h-4 w-4 cursor-grab rounded-full border-2 bg-white shadow-md outline-none transition-transform duration-150 hover:scale-110 focus-visible:ring-2 focus-visible:ring-offset-1 active:cursor-grabbing"
          style={{ borderColor: active.color }}
        />
      </SliderPrimitive.Root>

      <div className="mt-1.5 flex justify-between">
        {SPICE_LEVELS.map((s) => (
          <span
            key={s.level}
            className="h-1.5 w-1.5 rounded-full transition-colors"
            style={{ background: s.level <= value ? s.color : "#e2d8c6" }}
          />
        ))}
      </div>
    </div>
  );
};

export default SpiceSlider;
